import { DuesStatusType, type DuesStatus } from '~/shared/dues/status.js'

/**
 * Phosphor tag class for a dues status: paid is OK (green), unpaid needs
 * attention (gold), lifetime is an honor (purple), every other exemption is
 * neutral. See themes/palette.ts for the color rules.
 */
export function duesTagClass(type: DuesStatusType): string {
  switch (type) {
    case DuesStatusType.PAID:
      return 'kb-tag-ok'
    case DuesStatusType.UNPAID:
      return 'kb-tag-warn'
    case DuesStatusType.EXEMPT_LIFETIME:
      return 'kb-tag-honor'
    default:
      return 'kb-tag-neutral'
  }
}

export interface DuesNote {
  label: string
  /** PrimeIcons class */
  icon: string
  /** Same colors as duesTagClass, for the icon only */
  tone: 'ok' | 'warn' | 'honor' | 'neutral'
}

/**
 * A dues status as quiet row text with a colored mark, for list rows where a
 * tag would compete with the name (the captains in the admin SubKrewe drawer).
 */
export function duesNote(status: DuesStatus, paradeYear: string | number): DuesNote {
  switch (status.statusType) {
    case DuesStatusType.PAID:
      return { label: `Paid ${paradeYear} dues`, icon: 'pi-check-circle', tone: 'ok' }
    case DuesStatusType.UNPAID:
      return { label: `Owes ${paradeYear} dues`, icon: 'pi-exclamation-circle', tone: 'warn' }
    case DuesStatusType.EXEMPT_LIFETIME:
      return { label: 'No dues: lifetime', icon: 'pi-star', tone: 'honor' }
    default:
      return { label: `No dues: ${status.tagValue.toLowerCase()}`, icon: 'pi-minus-circle', tone: 'neutral' }
  }
}
